

























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ExamItem } from '@/app/exam/ui/exam-dashboard-types';
import { examsDashboardMixin } from '@/app/exam/ui/exams-dashboard-mixin';
import { examsDashboardTableMixin } from '@/app/exam/ui/exams-dashboard-table-mixin';
import LoadingComponent from '@/app/shared/components/loading-component.vue';
import FinalExamDashboardButtonComponent from '@/app/exam/ui/final-exam-dashboard-button-component.vue';
import WrapperCommonComponent from '@/app/shared/components/wrapper/wrapper-common-component.vue';
import UiProgressRingComponent from '@/app/shared/components/ui/ui-progress-ring-component.vue';
import UiScrollableComponent from '@/app/shared/components/ui/ui-scrollable-component.vue';

@Component({
  components: {
    LoadingComponent,
    WrapperCommonComponent,
    UiProgressRingComponent,
    UiScrollableComponent,
    FinalExamDashboardButtonComponent
  },
  mixins: [
    examsDashboardMixin,
    examsDashboardTableMixin
  ]
})
export default class ExamsMobileDashboardComponent extends Vue {
  @Prop()
  public loading: boolean;

  @Prop()
  public finalExam: ExamItem;

  @Prop()
  public passedExams: ExamItem[];

  @Prop()
  public remainingExams: ExamItem[];

  @Prop()
  public hasFinalExamInCourse: boolean;
}
